import { Component, OnInit, ViewEncapsulation, OnDestroy, EventEmitter, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { UntypedFormControl } from '@angular/forms';
import { BaseService } from 'app/_helpers/base/base.service';
import { Subject, merge } from 'rxjs';
import { startWith, takeUntil, switchMap, tap } from 'rxjs/operators';
import { forEach } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { FiltersComponent } from '../../filters/filters.component';
import { AuthenticationService } from 'app/services';

@Component({
  selector: 'app-wg-account-sources',
  templateUrl: './wg-account-sources.component.html',
  styleUrls: ['./wg-account-sources.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgAccountSourcesComponent implements OnInit, OnDestroy, AfterViewChecked {

  accountSources = new UntypedFormControl('this_month');
  widget6 = {} as any;
  results: any;
  systemLang: any;
  reload: EventEmitter<any> = new EventEmitter();
  loadData = false as boolean;
  searchDialogRef: any;
  filter = {} as any;
  user: any;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _gService: BaseService,
    private _translateService: TranslateService,
    private _matDialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private _authenticationService: AuthenticationService
  ) {
    this.widget6 = {
      currentRange: 'TW',
      legend: false,
      explodeSlices: false,
      labels: true,
      doughnut: false,
      gradient: false,
      scheme: {
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5', '#d124c8', '#5ecf25']
      },
      onSelect: (ev) => {
        console.log(ev);
      }
    };
    this.user = this._authenticationService.currentUserValue;
    this._translateService.onLangChange.pipe(startWith('')).subscribe(() => {
      this.systemLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
      this.reload.next(true);
    });
    if (this.user.user_role === 'agency_manager' && !this.user.user_office_data.master_office) {
      this.filter = { offices: [this.user.user_office_id] };
    } else if (this.user.user_role === 'agent' || this.user.user_role === 'agent_medium' || this.user.user_role === 'admin_agent_light') {
      this.filter = { users: [this.user._id] };
    }
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    merge(this.accountSources.valueChanges, this.reload)
      .pipe(
        startWith('this_month'),
        tap(() => this.loadData = true),
        takeUntil(this._unsubscribeAll),
        switchMap(() => {
          return this._gService.post(`dashboard/account_sources?range=${this.accountSources.value}`, {}, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        this.results = [];
        if (data.length) {
          forEach(data, (value) => {
            const temp = {} as any;
            temp.value = value.count;
            temp.name = value._id[this.systemLang] ? value._id[this.systemLang] : value._id.en;
            this.results.push(temp);
          });
        }
        this.loadData = false;
      });
  }

  openFilterModal(): void {
    this.searchDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
      data: 'userOffice',
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.filter = {};
          this.filter = response;
          this.reload.next(true);
        }
      });
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
